/*********************** Custom JS for Boost AI Search & Discovery  ************************/
if (window.boostSDAppConfig) { window.boostSDAppConfig.integration = Object.assign({ currencies: 'best' }, window.boostSDAppConfig.integration || {}); }



// const thisInput = document.querySelector(".boost-sd__search-widget-init-input");
// ['focus', 'click'].forEach((eventName) => {
//     thisInput.addEventListener(eventName, listener);
// });

// const listener = async (e) => {
//     const thisSuggestionResults = document.querySelector(".boost-sd__instant-search-results > div");
//     thisSuggestionResults.clientWidth = thisInput.clientWidth;
// }; 

window.__BoostCustomization__ = (window.__BoostCustomization__ ?? []).concat([(componentRegistry) => {
    componentRegistry.useComponentPlugin('SearchInput', {
        name: 'Update SearchInput',
        apply: () => ({
            props: (props) => {
                console.log("hiht", props);
                props.idSuggestionResults = "boostai-isw-results";

                return props;
            },
        }),
    });
}]);
window.__BoostCustomization__ = (window.__BoostCustomization__ ?? []).concat([(componentRegistry) => {
    componentRegistry.useComponentPlugin('SearchContentResult', {
        name: 'Update SearchInput Results',
        apply: () => ({
            props: (props) => {
                console.log("hihttttt", props);
                props.id = "boostai-isw-results";

                return props;
            },
        }),
    });
}]);